angular.module('satv.track')
    .factory('Tag', ['config', '$resource', '$http', '$q', function (config, $resource, $http, $q) {
        var resource = $resource(config.apiUri + '/tracks/:trackId/tags/:id', {
            trackId: '@trackId',
            id: '@id',
            cascade: '@cascade',
            lang: config.lang
        }, {
            save: {
                'method': 'POST',
                params: {cascade: '@cascade'}
            }
        });

        //for some reason when using the normal $resource save and delete there are some CORS issues
        //with Chrome and Firefox (the request remains pending). I am reasonably sure this is due
        //to $resource adding certain headers triggering an OPTIONS request.
        //The following $save and $delete methods override the usual functionality thereby bypassing
        //the problem. Mark Cremer <mark@4dutch.co.uk>
        resource.prototype.$save = function () {
            var delay = $q.defer();

            $http({
                url: config.apiUri + '/tracks/' + this.trackId + '/tags' + (this.cascade ? '?cascade=true' : ''),
                method: 'POST',
                data: {
                    keyword: this.keyword
                }
            }).success(function (data) {
                delay.resolve(data);
            });

            return delay.promise;
        };

        resource.prototype.$delete = function () {
            return $http({
                url: config.apiUri + '/tracks/' + this.trackId + '/tags/' + this.id + (this.cascade ? '?cascade=true' : ''),
                method: 'DELETE'
            });
        };

        resource.prototype.$copyTags = function () {
            var delay = $q.defer();

            $http({
                url: config.apiUri + '/tracks/' + this.trackId + '/copytags',
                method: 'POST',
                data: {
                    keywords: this.keywords
                }
            }).success(function (data) {
                delay.resolve(data);
            });

            return delay.promise;
        };

        return resource;
    }])

    .factory('TagsLoader', ['Tag', '$q', function (Tag, $q) {
        return function (params) {
            var delay = $q.defer();
            Tag.query(params, function (result) {
                delay.resolve(result);
            }, function () {
                delay.reject('Unable to fetch tags');
            });
            return delay.promise;
        };
    }])

;




// WEBPACK FOOTER //
// ./vendor/sonyatv/smfcoreclientbundle/Resources/js/angular/services/Tag.js